module.exports = __webpack_public_path__ + "img/flecha-dark.a1d0a7bf.svg";